import { render, staticRenderFns } from "./AddTeamForm.vue?vue&type=template&id=8d99493e"
import script from "./AddTeamForm.vue?vue&type=script&lang=js"
export * from "./AddTeamForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports